import { useEffect, useState } from "react"
import CreateBookForm from "../create/CreateBookForm";
import { loadBook } from "../bookUtils";


export default function UpdateBookIndex(props) {
  const [book, setBook] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      const bookData = await loadBook(props.lang);
      setBook(bookData);
      setLoading(false);
    }

    loadData();
  }, [])

  if (loading) {
    return (<> </>)
  }

  return (
    <CreateBookForm updateBook={true} bookRaw={book} lang={props.lang} />
  )
}